/**
 * smoke_detected anomaly marker styling (L.2.2, §6.2 + §3B.8).
 *
 * An uncorroborated camera smoke detection is visually DISTINCT from the
 * Response-Level anomaly map dots (now a single anomaly red): an AMBER dot
 * carrying the CAHS smoke kind-glyph (#305 — `cahs:smoke` via iconRegistry, see
 * layers/anomalyMarker `hazardGlyphBillboard`) that signals "needs operator eyes,
 * not yet a scored anomaly". STATIC — per the founder motion-budget revision
 * (2026-06-05, §3B.8) only live-camera dots and L3/L4 anomaly markers move; a
 * pending amber smoke dot never pulses and never carries a ring.
 */

/** Amber — "pending operator assessment", distinct from the anomaly map red. */
export const SMOKE_ANOMALY_COLOR = '#f59e0b';
export const SMOKE_ANOMALY_SIZE = 16;

/** The non-Response-Level badge shown in the queue row + detail panel. */
export const SMOKE_PENDING_BADGE_LABEL = 'Pending operator assessment';
